import Pagination from './Pagination';
import { withInstall } from '../_util/type';
export { PaginationProps, PaginationConfig } from './Pagination';
export default withInstall(Pagination);
